<template>
  <div>
    <page-title></page-title>
    <transition name="fade" mode="out-in">
      <div v-if="cardType==='list'" class="card bg-dark" key="list">
        <div class="card-body">
          <div class="table-header">
            <form>
              <div class="form-row">
                <div class="col-md-2 col-12 my-1">
                  <div class="dropdown  mr-md-2 mr-sm-0">
                    <button class="btn btn-secondary dropdown-toggle btn-block" type="button" id="dropdownMenuButton"
                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      {{search.status?search.status:'设备状态'}}
                    </button>
                    <div class="dropdown-menu bg-dark" aria-labelledby="dropdownMenuButton">
                      <button @click="searchStatus('在线')" type="button" class="dropdown-item">在线设备</button>
                      <button @click="searchStatus('离线')" type="button" class="dropdown-item">离线设备</button>
                      <button @click="searchStatus('异常')" type="button" class="dropdown-item">异常设备</button>
                      <button @click="searchStatus('')" type="button" class="dropdown-item">全部设备</button>
                    </div>
                  </div>
                </div>
                <div class="col-md-2 col-12 my-1">
                  <label class="sr-only">名称或设备号</label>
                  <input @keyup.enter="loadDevices" v-model="search.q" type="text" class="form-control form-control mr-md-2 mr-sm-0"
                         placeholder="名称或设备号">
                </div>
                <div class="col-md-2 col-12 my-1">
                  <button @click="loadDevices"  @keyup.enter="loadDevices" type="button" class="btn btn btn-primary btn-block">搜索</button>
                </div>
                <div class="col-md-2 col-12 my-1 ml-auto">
                  <button v-if="role!=='employee'" type="button" @click="clickEditDevice('add')" class="btn btn btn-success  btn-block"><i
                    class="iconfont icon-c_add"></i> 添加设备
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div class="table-responsive" v-if="devices&&devices.length">
            <table class="table table-leemma  ">
              <thead>
              <tr>
                <th>设备号</th>
                <th>名称</th>
                <th>类型</th>
                <th>用户数</th>
                <th>地址</th>
                <th>激活码</th>
                <th>联系电话</th>
                <th>备注</th>
                <th>状态</th>
                <th v-if="role!=='employee'">操作</th>

              </tr>
              </thead>
              <tbody>
              <tr v-for="(device,index) in devices">
                <td><a target="_blank" :href="customerUrl + device.id">{{device.device_sn}}</a></td>
                <td><a target="_blank" :href="customerUrl + device.id">{{device.name}}</a></td>
                <td>{{device.category}}</td>
                <td>{{device.customers}}</td>
                <td>{{district[device.province]}}-{{district[device.city]}}-{{district[device.district]}}</td>
                <td>{{device.code}}</td>
                <td>{{device.phone_number}}</td>
                <td>{{device.remark}}</td>
                <td :data-toggle="device.status==='在线'?'':'tooltip'" data-placement="left" :title="device.status_dec"
                    :class="{'status-success':device.status==='在线','status-danger':device.status!=='在线'}">
                  {{device.status?device.status:'异常'}}
                </td>

                <td v-if="role!=='employee'">
                  <button @click="clickEditDevice('edit',index)" class="btn btn-primary btn-sm">修改信息</button>
                  <button @click="deleteDevice(index)" class="btn  btn-outline-danger btn-sm">删除设备</button>
                </td>
              </tr>
              </tbody>
            </table>
            <div>
            </div>
            <page :page-size="search.pageSize" :count="search.count" :page-no="search.pageNo" @click="paging"></page>

          </div>
          <div v-else>暂无数据</div>

        </div>
      </div>
      <div v-else-if="cardType==='edit'||cardType==='add'" class="card bg-dark" key="edit">
        <div class="card-body">
          <form>
            <div class="form-group">
              <label>名称</label>
              <input v-model="deviceInfo.name" type="text" class="form-control" placeholder="请输入名称">
            </div>

            <div class="form-group">
              <label>DTU号</label>
              <input v-model="deviceInfo.device_sn" type="text" class="form-control" placeholder="请输入DTU号">
            </div>
            <div class="form-group">
              <label>砖窑数</label>
              <input v-model="deviceInfo.alias_m" type="text" class="form-control" placeholder="请输入砖窑数(1~6)">
            </div>
            <div class="form-group">
              <label>地址</label>
              <v-distpicker :placeholders="distPlaceholder" v-on:selected="selectedArea"></v-distpicker>
            </div>
            <div class="form-group">
              <label>设备类型</label>
              <select class="form-control" v-model="deviceInfo.category_id">
                <option v-for="item in categories" :value="item.id">{{item.name}}</option>
              </select>
            </div>
            <div class="form-group">
              <label>联系方式</label>
              <input v-model="deviceInfo.phone_number" type="text" class="form-control" placeholder="请输入联系方式">
            </div>
            <div class="form-group">
              <label>备注</label>
              <input v-model="deviceInfo.remark" type="text" class="form-control" placeholder="请输入备注">
            </div>

            <button type="button" v-if="cardType==='add'" @click="addDevice" class="btn btn-primary">确定</button>
            <button type="button" v-if="cardType==='edit'" @click="saveDevice" class="btn btn-primary">确定</button>
            <button type="button" @click="cardType='list'" class="btn btn-link">取消</button>
          </form>
        </div>
      </div>
    </transition>
  </div>

</template>

<script>
  import pageTitle from '@/components/pageTitle'
  import VDistpicker from 'v-distpicker'
  import district from '@/assets/lib/district'
  import {mapState} from 'vuex'
  import page from '@/components/pagination'


  export default {
    name: 'devices',
    components: {
      pageTitle,
      VDistpicker,
      page
    },
    data() {
      return {
        role:'',
        customerUrl: '',
        cardType: 'list',
        devices: [],
        deviceInfo: {},
        search: {
          pageNo: 1,
          pageSize: 15,
          count: 0,
          q: '',
          status: '',
          dev_sn: '',
          prov: '',
          category_id: ''
        },
        categories: [],
        district,
        distPlaceholder: {
          province: '--',
          city: '--',
          district: '--'
        }
      }
    },
    computed: {
      ...mapState({
        account: status => status.account
      })
    },
    created() {
      this.loadDevices();
      this.loadCategories();
      this.checkUser();
    },
    mounted() {
      this.customerUrl = this.$config.leemmaCustomer + '/login?user_token=' + this.account.info.auth_token + '&device_id='
      if (this.$route.query.type === 'list') {
        this.cardType = 'list'
      }
    },

    methods: {
      checkUser(){
        this.role=this.account.info.role
      },
      paging(no) {
        this.search.pageNo = no;
        this.loadDevices()
      },
      selectedArea(area) {
        this.deviceInfo.province = area.province.code;
        this.deviceInfo.city = area.city.code;
        this.deviceInfo.district = area.area.code;

      },
      searchStatus(type) {
        this.search.status = type;
        this.search.pageNo = 1;
        this.loadDevices()
      },
      loadDevices() {
        let url = 'devices',
          s = this.search,
          params = {
            auth_token: "default",
            page_size: this.search.pageSize,
            page_no: this.search.pageNo,
            status: this.search.status
          };
        s.q ? params.q = s.q : '';
        this.$http.get(url, {params})
          .then(data => {
            if (data.status_code === 'SUCCEEDED') {
              this.cardType = 'list';
              this.devices = data.payload;
              this.search.count = data.total;
              this.$nextTick(() => {
                $(function () {
                  $('[data-toggle="tooltip"]').tooltip()
                })
              })
            }
          })
      },
      loadCategories() {
        let url = 'categories',
          params = {
            auth_token: 'default'
          }
        this.$http.get(url, {params}).then(data => {
          if (data.status_code === 'SUCCEEDED') {
            this.categories = data.payload;

          }
        })
      },
      clickEditDevice(type, index) {
        this.cardType = type;
        if (type === 'add') {
          this.deviceInfo = {}
        } else if (type === 'edit') {
          let device = this.devices[index];
          this.deviceInfo = device;
          this.distPlaceholder = {
            province: district[device.province], city: district[device.city], district: district[device.district]
          }
        }
      },
      addDevice() {
        let url = 'devices/create',
          params = this.deviceInfo;
        params.auth_token = 'default';
        this.$http.post(url, params).then(data => {
          if (data.status_code === 'SUCCEEDED') {
            this.$message.success('操作成功')
            this.loadDevices();

          } else {
            this.$message.error('操作失败:' + data.msg)
          }

        })
      },
      saveDevice() {
        let device = this.deviceInfo,
          url = `devices/${device.id}/edit`,
          params = device;
        params.auth_token = 'default';
        this.$http.patch(url, params).then(data => {
          if (data.status_code === 'SUCCEEDED') {
            this.$message.success('操作成功')
            this.loadDevices();

          } else {
            this.$message.error('操作失败:' + data.msg)
          }
        })
      },
      deleteDevice(index) {
        this.$confirm('确认删除设备？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let device = this.devices[index],
            url = `devices/${device.id}/destroy`,
            params = {auth_token: 'default'};
          this.$http.delete(url, {params}).then(data => {
            if (data.status_code === 'SUCCEEDED') {
              this.$message.success('删除成功')
              this.loadDevices()
            } else {
              this.$message.error('操作失败:' + data.msg)
            }
          })
        })

      }
    }

  }
</script>

<style type="scss" scoped>
  .fade-enter-active, .fade-leave-active {
    transition: all .3s
  }

  .fade-enter {
    opacity: 0;
    transform: translateX(-10px);
  }

  .fade-leave-to {
    opacity: 0;
    transform: translateX(10px);
  }

  .bg-dark .dropdown-item {
    color: #fff;
  }

  .bg-dark .dropdown-item:hover {
    color: #000;
  }
</style>



// WEBPACK FOOTER //
// src/view/devices.vue